import { render } from "./editarClinica.vue?vue&type=template&id=684def6f&scoped=true"
import script from "./editarClinica.vue?vue&type=script&lang=js"
export * from "./editarClinica.vue?vue&type=script&lang=js"

import "./editarClinica.vue?vue&type=style&index=0&id=684def6f&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\reclasin-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-684def6f"]])

export default __exports__